// @ts-check
import React, { memo } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core'; // eslint-disable-line no-unused-vars
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/** @typedef {{
 * className?: string; icon: IconProp
}} FAIconProps */

/** @type { React.FC<FAIconProps> } */
export const FAIcon = memo(({ className, icon }) => {
  return <FontAwesomeIcon className={className} icon={icon} />;
});
